import ProductType from 'apps/products/models/ProductType';

export function isRegularProduct(product) {
  return product.type === ProductType.REGULAR;
}

export function isNotSellingGroup(product) {
  return product.type === ProductType.REGULAR ||
    product.type === ProductType.SERVICE_COUNTER_DERIVATIVE ||
    product.type === ProductType.PRODUCT_GROUP_DERIVATIVE;
}
